<style>
    .step-row {
        font-size: .7em;
        line-height: 1.2;
    }
    .text-block {
        padding: 1em;
    }
    .draggable {
        transition: background-color 0.5s ease;
        background-color: transparent;
        cursor: grab;
    }
    .draggable.no-drag {
        cursor: default;
    }
    .dragging {
        cursor: grabbing;
    }
</style>

<template>
    <div class="component-container">
        <div class="d-flex justify-content-between align-items-stretch mb-0">
            <h5 class="bg-primary text-white p-3 mb-0" style="width: 75%; border-radius: 10px 10px 0 0;">
                <span v-show="edit">Change Action </span>Steps
                <div v-show="edit">
                    <small>
                        <u BPopover.click.blur="'To change the wording of a step, click the pencil icon and type in the box.'">Edit</u>,
                        <u BPopover.click.blur="'To delete a step, click the X.'">delete</u>,
                        <u BPopover.click.blur="'To reorder a step, click and drag it. The other steps will shift.'">reorder</u>
                        or
                        <u BPopover.click.blur="'To add a new step, click the + Add a Step button below.'">add new steps</u>.
                    </small>
                </div>
            </h5>
            <h5 class="bg-primary text-white p-3 mb-0" style="width: 22%;  border-radius: 10px 10px 0 0;">Add Support People or Notes</h5>
        </div>
        
        <draggable
            :options="dragOptions" 
            v-on:sort="startReorderTimeout" 
            v-model="apCopy.steps"
            item-key="apCopy.id"
        >
            <template #item="{ element }">
                <action-plan-step
                    :key="element.id"
                    :id="'step-'+element.id"
                    :step="element" 
                    v-on:update="updateStep($event)"
                    v-on:delete="deleteStep($event)"
                    :edit="edit"
                    :completed-mode="isComplete"
                    ref="stepComponent"
                    :class="waiting ? 'no-drag' : ''" 
                ></action-plan-step>
            </template>
        </draggable>

        <div v-show="edit">
            <div class="d-flex justify-content-between step-row mt-0">
                <div class="w-75 bg-secondary">
                    <button class="btn btn-link text-white" v-on:click="addStep($event)" :disabled="hasPendingNewStep()">
                        <span class="fa fa-plus"></span>
                        Add a Step
                    </button>
                </div>
                <div class="bg-secondary" style="width: 22%">
                    &nbsp;
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ActionPlanStep from './ActionPlanStep'
    import draggable from "vuedraggable";
    import { nextTick } from 'vue';

    export default {
        components: {
            ActionPlanStep,
            draggable,
        },
        props: {
            actionPlan: {
                required: true,
                type: Object
            },
            edit: {
                required: true,
                type: Boolean
            }
        },
        data() {
            return {
                apCopy: {
                    steps: []
                },
                reorderTimeout: null,
                waiting: false
            }
        },
        computed: {
            dragOptions: function () {
                let options = {
                    draggable: '.draggable',
                    dragClass: 'bg-info',
                    chosenClass: 'bg-info',
                    ghostClass: 'bg-info',
                }
                if (this.waiting) {
                    options.draggable = '.drag-disabled'
                }
                return options
            },
            currentLastStep: function () {
                let orders = this.apCopy.steps.map((item) => item.order)
                                .sort((a,b) => {
                                    if (a > b)
                                        return -1;
                                    if (a < b)
                                        return 1;
                                    return 0;
                                })
                return orders[0]
            },
            isComplete: function () {
                return (this.apCopy.date_completed !== null)
            },
            steps: function () {
                return this.apCopy.steps
            }
        },
        watch: {
            actionPlan: function () {
                this.syncActionPlan()
            }
        },
        methods: {
            startReorderTimeout(evt) {
                nextTick(() => {
                    evt.item.classList.add('bg-info');
                })

                this.reorderTimout = setTimeout(() => {
                    this.reorderSteps(evt)
                    nextTick(() => {
                        evt.item.classList.remove('bg-info');
                    })
                }, 1000);
            },
            reorderSteps(evt) {
                this.apCopy.steps.forEach((step, idx) => {
                    step.order = idx+1
                    nextTick(() => {
                        this.updateSteps(JSON.parse(JSON.stringify(step)))
                    })
                })
                this.waiting = true;
                axios.put('/api/action-plans/'+this.apCopy.id, {
                    action: 'reorder-steps',
                    steps: this.apCopy.steps
                })
                .catch(error => {
                    alert('There was a problem reordering steps.'); console.error(error)
                })                        
                .then(response => {
                    this.waiting = false
                })
            },
            hasPendingNewStep () {
                return this.apCopy.steps.filter((item) => item.id === null).length > 0
            },
            addStep() {
                let newStep = {
                    id: 0,
                    text: '',
                    order: this.currentLastStep+1,
                    date_completed: null,
                    notes: ''
                };
                this.apCopy.steps.push(newStep);
                nextTick(() => {
                    this.$refs.stepComponent[this.apCopy.steps.length-1].editStep();
                })
                    
            },
            updateSteps(data) {
                let stepIdx = -1;
                for (var i = 0; i < this.apCopy.steps.length; ++i) {
                    if (this.apCopy.steps[i].id == data.id) {
                        stepIdx = i;
                        break;
                    }
                }

                // const stepIdx = this.apCopy.steps.findIndex((item) => (item.id == data.id));
                this.apCopy.steps.splice(stepIdx, 1, data);
            },
            createStep(newStepData) {
                if (newStepData.text === '') {
                    return;
                }
                newStepData.action_plan_id = this.actionPlan.id
                this.waiting = true;
                axios.post('/api/action-plan-steps', newStepData)
                    .then((response) => {
                        console.log('completed create step');
                        this.updateSteps(response.data)
                    })
                    .catch((error) => {
                        alert('Problem Creating new step.');
                    })
                    .then(response => {
                        this.waiting = false;
                    })
            },
            updateStep(newStepData) {
                if (!newStepData.id || newStepData.id == 0) {
                    this.createStep(newStepData);
                    return;
                }
                this.waiting = true;
                axios.put('/api/action-plan-steps/'+newStepData.id, newStepData)
                    .then((response) => {
                        this.updateSteps(response.data)
                    })
                    .catch((error) => {
                        console.error(error);
                        alert('Problem updating step');
                    })
                    .then(response => {
                        this.waiting = false;
                    })
            },
            deleteStep(step) {
                const stepIdx = this.apCopy.steps.findIndex((item) => (item.id == step.id && item.order == step.order));
                if (!step.id) {
                    this.apCopy.steps.splice(stepIdx, 1);
                    return
                }
                this.waiting = true;
                axios({
                    method: 'delete',
                    url: '/api/action-plan-steps/'+step.id
                }).then((response) => {
                    this.apCopy.steps.splice(stepIdx, 1);
                }).catch((error) => {
                    console.error(error);
                    alert('problem deleting step.');
                })
                .then(response => {
                    this.waiting = false;
                    this.reorderSteps();
                })
            },
            syncActionPlan() {
                this.apCopy = JSON.parse(JSON.stringify(this.actionPlan))
            },
            updateEditingSteps() {
                Array.from(this.$refs.stepComponent).forEach(ref => {
                    ref.updateStep()
                })
            }
        },
        mounted() {
            this.syncActionPlan()
        }
    
}
</script>